import axios from 'axios';
import { isServer } from '../../../server/helpers/browserDetector';

/* My new server */
// const API_URL = "http://authentication-jwt/api/";
// const API_URL = "http://content-server/interface/remote/";
// const API_URL = "http://smartbooker.biz/interface/remote/";
const API_URL = `${process.env.REACT_APP_SMART_URL}interface/remote/`;

async function smartPost(url, data) {
  if (isServer) return axios.post(url, data);
  return axios.post(`${process.env.REACT_APP_URL}api/smart-proxy`, { url, method: 'POST', data });
}

// ##### 23-10-27 Komarov
const register = (
  firstName,
  lastName,
  username,
  email,
  password,
  promocode,
  locale
) => {
  return smartPost(
    `${API_URL}create_user`,
    JSON.stringify({
      firstname: firstName,
      lastname: lastName,
      username: username,
      email: email,
      password: password,
      promocode: promocode,
      locale: locale,
    })
  );
};

const login = (username, password) => {
  return smartPost(
    `${API_URL}login`,
    JSON.stringify({
      username: username,
      password: password,
    })
  ).then(response => {
    if (response.data.accessToken) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  });
};

const logout = () => {
  localStorage.removeItem('user');
};

const authService = {
  register,
  login,
  logout,
};

export default authService;
